﻿import { mutations } from "@/graphql";
import { useMutation } from "@apollo/client/react";
import { useCallback } from "react";
import { enqueueSnackbar } from "notistack";
import type { MutationDeleteDataLimitArgs } from "@/types/graphql";
/**
 * Custom hook to delete a module.
 * @param {Function} [onCompleted] - Callback function to be called when the mutation completes successfully.
 * @param {Function} [onError] - Callback function to be called when an error occurs during the mutation.
 * @returns {{deleteModule: Function, deleting: boolean}} - The function to delete a module and the loading state.
 */
export function useDeleteDataLimit(
  onCompleted: (data?: any) => void = () => {},
  onError: (error?: any) => void = () => {},
) {
  const [deleteDataLimit, { loading }] = useMutation<
    any,
    MutationDeleteDataLimitArgs
  >(mutations.deleteDataLimit, {
    onCompleted,
    onError: (err) => {
      onError(err);

      enqueueSnackbar("Delete Module: " + err.message, {
        variant: "error",
      });
    },
    errorPolicy: "all",
  });

  const deleteDataLimitRow = useCallback(
    (variables: MutationDeleteDataLimitArgs) => {
      deleteDataLimit({
        variables,
        refetchQueries: ["DataLimitList"],
      }).then();
    },
    [deleteDataLimit],
  );

  return {
    deleteDataLimit: deleteDataLimitRow,
    deleting: loading,
  };
}
